function LoadingScreen() {
  return <div className="hidden appear loading-screen">Loading...</div>
}
export default LoadingScreen
